const { h, render, Component } = require('preact');
const BreadcrumbItem = require('./breadcrumb_item')
const BreadcrumbSeparator = require('./separator')

class Breadcrumbs extends Component {
    constructor(props) {
      super(props)
      this.getBreadCrumbItems = this.getBreadCrumbItems.bind(this);
    }

    getUrlForCrumb(url){
      // Handling the Customer Support breadcrumb for contact channels page coming in the flow -
      // Logged out experience ==> Any FAQ - Still Need Help ==> Login page ==> Contact Channels page
      let redirectedContactChannelsUrlRegex = /\/customer_support\?showContactChannels/g;
      if (url.search(redirectedContactChannelsUrlRegex) > -1){
        let configFromDom = Groupon.Utils.getConfigFromDom();
        if (configFromDom && configFromDom.SUPPORTBASEURL)
          return configFromDom.SUPPORTBASEURL
      }
      else
        return url;
    }

    getBreadCrumbItems(){
      let listItems = []
      for(let crumb in this.props.crumbs)
      {
        listItems.push(<BreadcrumbItem
                          text={this.props.crumbs[crumb].text}
                          url={this.getUrlForCrumb(this.props.crumbs[crumb].url)}
                          handleCrumbClick = {this.props.handleCrumbClick}
                      />)
        listItems.push(<BreadcrumbSeparator/>)
      }
      listItems = listItems.splice(0,listItems.length-1)
      return listItems
    }

    render() {
      if(this.props.crumbs && this.props.crumbs.length>1){
        return (<div class="breadcrumbs" id="breadcrumbs">
                  <div class="main row cs_support_header">
                    <nav class="relative breadcrumb-nav" data-bhw="breadcrumbs">
                      <ul class="unstyled breadcrumb">
                        {this.getBreadCrumbItems()}
                      </ul>
                    </nav>
                  </div>
                </div>)
        }
      return null
    }
}

module.exports = Breadcrumbs
